"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorAndShadeKeys = void 0;
var _lodash = _interopRequireDefault(require("lodash.lowerfirst"));
const ColorAndShadeRegex = /[A-Z][a-z]+|\d+/g;
/**
 * Gets possible keys of `theme.palette` and `theme.palette[color]` objects.
 * @returns Possible keys of `theme.palette` and `theme.palette[color]` objects.
 */
const getColorAndShadeKeys = ({
  backendColor,
  palette
}) => {
  const parts = backendColor.match(ColorAndShadeRegex);
  if (!parts || parts.length < 2 || parts.length > 4) {
    return null;
  }
  const [part0, part1, part2, part3] = parts;
  if (parts.length === 2) {
    return {
      color: (0, _lodash.default)(part0),
      shade: (0, _lodash.default)(part1)
    };
  }
  if (parts.length === 3 && part0 && part1 && part2) {
    const possibleColor = (0, _lodash.default)(part0 + part1);
    const possibleShade = (0, _lodash.default)(part1 + part2);
    if (Object.keys(palette).includes(possibleColor)) {
      return {
        color: possibleColor,
        shade: (0, _lodash.default)(part2)
      };
    }
    return {
      color: (0, _lodash.default)(part0),
      shade: possibleShade
    };
  }
  /* istanbul ignore next */
  if (parts.length === 4 && part0 && part1 && part2 && part3) {
    return {
      color: (0, _lodash.default)(part0 + part1),
      shade: (0, _lodash.default)(part2 + part3)
    };
  }
  /* istanbul ignore next */

  return null;
};
exports.getColorAndShadeKeys = getColorAndShadeKeys;
//# sourceMappingURL=getColorAndShadeKeys.js.map